/**
 * BranchCarousel
 * ======================================
 * - toggle class on tab nav item
 * - toggle hidden attribute on tabs
 * - html markup required (js-tabs-select, js-tabs-nav, js-tabs-list)
 * - support for mobile select
 * - support multiple widgets
 */

 const WIDGET = '.js-BranchCarousel'
 const ACTIVECLASS = 'is-active'

 class BranchCarousel {
   constructor() {
     this.elements = document.querySelectorAll(WIDGET)

     this.elements.forEach((el) => {
       const nav = el.querySelectorAll('.js-BranchCarousel-nav > *')

       nav.forEach((el) => {
         el.addEventListener('click', this.clickHandler, false)
       })
     })
   }

   clickHandler = (e) => {
     const button = e.currentTarget
     const widget = button.closest(WIDGET)
     const label = widget.querySelector('.branch-carousel__dropdown-btn')

     this.switchTab(widget, this.getIndex(button))
     button.classList.add(ACTIVECLASS)
     label.querySelector('span').innerHTML = button.innerHTML
   }

   switchTab = (widget, index) => {
     const tabs = widget.querySelectorAll('.branch-carousel__tabs > *')

     this.reset(widget)

     tabs.forEach((tab) => {
       if (this.getIndex(tab) === index) {
         tab.classList.add(ACTIVECLASS)
       }
     })

     window.dispatchEvent(new CustomEvent('scroll'))
   }

   getIndex = (el) => {
     return [...el.parentNode.children].indexOf(el)
   }

   reset = (widget) => {
     const nav = widget.querySelectorAll('.js-BranchCarousel-nav > *')
     const tabs = widget.querySelectorAll('.branch-carousel__tabs > *')

     nav.forEach((button) => {
       button.classList.remove(ACTIVECLASS)
     })

     tabs.forEach((tab) => {
       tab.classList.remove(ACTIVECLASS)
     })
   }
 }

 new BranchCarousel()
